export const showNotification = (title, options) => {
    if (Notification.permission === "granted") {
      new Notification(title, options);
    } else {
      console.warn("Уведомления не разрешены пользователем");
    }
  };